// extracted by mini-css-extract-plugin
export var editInput = "_k6-0";
export var editInputCompact = "_k6-2";
export var editInputLarge = "_k6-1";
export var editInputSmall = "_k6-3";